var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContinueLaterFolder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#continue_later_folder_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#continue_later_folder_svg__b)",
  d: "M0 0h36v36H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#090C0F",
  fillOpacity: 0.05,
  d: "M0 0h36v36H0z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.133 9.666h3.735c.671 0 1.225 0 1.676.037.468.039.899.12 1.303.327.627.32 1.137.83 1.457 1.457.206.404.288.835.327 1.303.036.451.036 1.005.036 1.675V25.5a.833.833 0 0 1-1.247.723L18 23.126l-5.42 3.097a.833.833 0 0 1-1.246-.723V14.465c0-.67 0-1.224.037-1.675.038-.468.12-.899.326-1.303.32-.628.83-1.138 1.457-1.457.405-.206.835-.288 1.303-.327.451-.037 1.005-.037 1.676-.037Z",
  fill: "#F9F9F9"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 35,
  rx: 17.5,
  stroke: "#fff",
  strokeOpacity: 0.15
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "continue_later_folder_svg__b",
  x1: 18,
  y1: 0,
  x2: 18,
  y2: 36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4BA5FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#004677"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "continue_later_folder_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("image", {
  id: "continue_later_folder_svg__c",
  width: 64,
  height: 64,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAONJREFUeF7t20EOhEAIRFG4/6F7DvEnYeFzryQIv6pBd2behOu9dPvsbog+k+NLgArQAqmJcw9iAAhSgZKB3IJkkAySQTJ4CiE+gA8oBeg0mH3Ai084P89HhqwEqIA209ICsQdjAeaZIgaAYKxBDMCAYy8fXwAIgiAIcoJpJEYGI4VjB3YrbC9gL2AvkCB43cM5PgZgAAZgQFnNZAhdGykQBEEQBEEQDBmgAm2glM/z+QUYisYUGoldO7kY32IEAzCg6RgIRgjFAsw+AgRBMNYgBmCAT2TCYfoPPz/HCqQCX1eBHzHnv7C7WhBSAAAAAElFTkSuQmCC"
}))));
export default SvgContinueLaterFolder;